/**
 * Video Slider section – Swiper init for mobile, video play/pause on click.
 * Mobile: 1.25 slides, loop, custom nav + count. Desktop: grid.
 */
(function() {
  function initVideoSliderSwiper(container) {
    if (typeof window.Swiper === 'undefined') return;
    const section = container.closest('.el-video-slider-section');
    if (!section) return;
    const slider = section.querySelector('.el-video-slider__slider');
    const prevBtn = section.querySelector('[data-video-prev]');
    const nextBtn = section.querySelector('[data-video-next]');
    const countEl = section.querySelector('[data-video-count]');
    const slideCount = section.querySelectorAll('.el-video-slider__slide').length;
    if (!slider || slider.swiper) return;

    const videoSliderSwiper = new window.Swiper(slider, {
      loop: true,
      speed: 300,
      breakpoints: { 0: { slidesPerView: 1.25, spaceBetween: 16 }, 981: { slidesPerView: 4, spaceBetween: 24 } },
      keyboard: { enabled: true, onlyInViewport: true },
      on: {
        slideChange: function() {
          if (countEl && slideCount) {
            const realIndex = this.realIndex + 1;
            countEl.textContent = realIndex + '/' + slideCount;
          }
        }
      }
    });

    if (prevBtn) prevBtn.addEventListener('click', function() { videoSliderSwiper.slidePrev(); });
    if (nextBtn) nextBtn.addEventListener('click', function() { videoSliderSwiper.slideNext(); });
  }

  function initVideoPlayPause() {
    if (document.body.dataset.videoSliderClickInit) return;
    document.body.dataset.videoSliderClickInit = '1';
    document.addEventListener('click', function(e) {
      var item = e.target.closest('[data-video-slider-item]');
      if (!item) return;

      var playBtn = item.querySelector('[data-play-btn]');
      var poster = item.querySelector('[data-poster]');
      var videoWrap = item.querySelector('[data-video-wrap]');
      var nativeVideo = item.querySelector('video.el-video-slider-item__native');
      var iframe = item.querySelector('iframe[data-video-src]');

      function showPlaying() {
        if (poster) poster.classList.add('is-hidden');
        if (playBtn) playBtn.classList.add('is-hidden');
        if (videoWrap) videoWrap.classList.add('is-playing');
      }
      function showPaused() {
        if (poster) poster.classList.remove('is-hidden');
        if (playBtn) playBtn.classList.remove('is-hidden');
        if (videoWrap) videoWrap.classList.remove('is-playing');
      }

      function play() {
        if (nativeVideo) {
          nativeVideo.play().then(function() { showPlaying(); }).catch(function() {});
        } else if (iframe) {
          var src = iframe.getAttribute('data-video-src') || '';
          if (src && !iframe.src) {
            src += src.indexOf('?') >= 0 ? '&' : '?';
            src += 'autoplay=1';
            iframe.src = src;
          }
          showPlaying();
        }
      }
      function pause() {
        if (nativeVideo) {
          nativeVideo.pause();
        } else if (iframe) {
          iframe.src = '';
        }
        showPaused();
      }

      function toggle() {
        if (videoWrap && videoWrap.classList.contains('is-playing')) {
          pause();
        } else {
          play();
        }
      }

      e.preventDefault();
      toggle();
    });

    document.querySelectorAll('[data-video-slider-item]').forEach(function(item) {
      var nativeVideo = item.querySelector('video.el-video-slider-item__native');
      if (!nativeVideo) return;
      var playBtn = item.querySelector('[data-play-btn]');
      var poster = item.querySelector('[data-poster]');
      var videoWrap = item.querySelector('[data-video-wrap]');
      function showPlaying() {
        if (poster) poster.classList.add('is-hidden');
        if (playBtn) playBtn.classList.add('is-hidden');
        if (videoWrap) videoWrap.classList.add('is-playing');
      }
      function showPaused() {
        if (poster) poster.classList.remove('is-hidden');
        if (playBtn) playBtn.classList.remove('is-hidden');
        if (videoWrap) videoWrap.classList.remove('is-playing');
      }
      nativeVideo.addEventListener('play', showPlaying);
      nativeVideo.addEventListener('pause', showPaused);
    });
  }

  function runInits() {
    document.querySelectorAll('[data-video-slider-swiper]').forEach(function(container) {
      initVideoSliderSwiper(container);
    });
    initVideoPlayPause();
  }

  if (typeof window.Swiper !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runInits);
    else runInits();
    return;
  }
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.css';
  document.head.appendChild(link);
  const s = document.createElement('script');
  s.src = 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.js';
  s.onload = function() {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runInits);
    else runInits();
  };
  document.head.appendChild(s);
})();
